import { Breadcrumb } from '../types/breadcrumb';

export const filterPreRootCrumbs = (crumbs: Breadcrumb[]) => {
  let rootCrumbIndex = 0;
  crumbs.forEach((crumb, index) => {
    if (crumb.isRoot) {
      rootCrumbIndex = index;
    }
  });
  return crumbs.filter((_crumb, index) => index >= rootCrumbIndex);
};
